// LoadingMask.jsx
import React from 'react';
import './loadingMaskStyle.scss'

const LoadingMask = () => (
    <div className="loading-mask">
      <div className="loading-spinner"></div>
    </div>
  );
  

export default LoadingMask;